// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bal_a"};